export default "__VITE_ASSET__DlfIYa5F__"